import React from 'react';
import { IconProps } from '.';

export const Info: React.FC<IconProps> = ({
  className = '',
}: IconProps): JSX.Element => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.5 5C9.5 7.48528 7.48528 9.5 5 9.5C2.51472 9.5 0.5 7.48528 0.5 5C0.5 2.51472 2.51472 0.5 5 0.5C7.48528 0.5 9.5 2.51472 9.5 5Z"
        stroke="#ACBBF5"
      />
      <path
        d="M5.37744 7.47339C5.37744 7.69519 5.19763 7.875 4.97583 7.875C4.75403 7.875 4.57422 7.69519 4.57422 7.47339V4.49634C4.57422 4.27453 4.75403 4.09473 4.97583 4.09473C5.19763 4.09473 5.37744 4.27453 5.37744 4.49634V7.47339ZM4.52637 3.09326C4.52637 2.94971 4.5651 2.83919 4.64258 2.76172C4.72233 2.68424 4.83512 2.64551 4.98096 2.64551C5.12223 2.64551 5.23161 2.68424 5.30908 2.76172C5.38883 2.83919 5.42871 2.94971 5.42871 3.09326C5.42871 3.22998 5.38883 3.33822 5.30908 3.41797C5.23161 3.49544 5.12223 3.53418 4.98096 3.53418C4.83512 3.53418 4.72233 3.49544 4.64258 3.41797C4.5651 3.33822 4.52637 3.22998 4.52637 3.09326Z"
        fill="#ACBBF5"
      />
    </svg>
  );
};
